import React from 'react'
import {Modal} from 'react-responsive-modal'
class WarningModal extends React.Component{
    render(){
        return(
            <Modal 
            open={this.props.open} 
            onClose={this.props.onClose} 
            onOverlayClick={this.props.onClose}
            classNames={{
                modal: "customModal",
                closeButton:"customCloseButton",
                closeIcon:"customCloseIcon"
            }}
            center>
                <h3 style={{marginTop: '1.5rem'}}>
                To play VR Videos on your iOS device, please go to ‘Settings’ – ‘Safari’ and enable ‘Motion &amp; Orientation Access’.
                </h3>
            </Modal>
        );
    }
}

export default WarningModal


// WEBPACK FOOTER //
// ./src/components/Play/WarningModal.js